module.exports = __webpack_public_path__ + "static/media/9010_9005.b92b917b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/9010_9005.jpg
// module id = 704
// module chunks = 0